import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { PermissionDto, RoleDetailDto } from "../../pages/role-list/models/role-models";
import { CheckboxUpdateService } from "../../services/checkbox-update.service";
import { ClaimCheckBoxItem } from "src/app/pages/payment-list/models/payment.models";
import { CheckAllProps } from "./checkbox-model";

export interface CheckItem {
	id: number;
	name: string | null;
	state: boolean;
}

@Component({
	selector: "app-checkbox-block",
	templateUrl: "./checkbox-block.component.html",
	styleUrls: ["./checkbox-block.component.scss"],
})
export class CheckboxBlockComponent implements OnInit, OnDestroy, OnChanges {
	@Input() checkList?: CheckItem[] = [];
	@Input() title = "";

	@Output() checkboxChange: EventEmitter<CheckItem> = new EventEmitter<CheckItem>();
	@Output() checkboxChangeAll: EventEmitter<CheckAllProps> = new EventEmitter<CheckAllProps>();

	stateCheckAll = "unchecked";

	aSub: Subscription | undefined;

	constructor(private checkboxUpdateService: CheckboxUpdateService) {}

	ngOnInit() {
		this.setStateCheckboxAll();
		this.initPermissionItems();
	}

	ngOnChanges() {
		this.setStateCheckboxAll();
	}

	ngOnDestroy() {
		this.aSub?.unsubscribe();
	}

	initPermissionItems() {
		this.aSub = this.checkboxUpdateService.checkboxUpdate$.subscribe({
			next: () => {
				this.stateCheckAll = "unchecked";
				this.setStateCheckboxAll();
			},
		});
	}

	checkAll() {
		if (this.checkList) {
			const checkboxChangeProps: CheckAllProps = {
				itemList: this.checkList,
				state: this.stateCheckAll !== "checked",
			};

			this.checkboxChangeAll.emit(checkboxChangeProps);

			this.setStateCheckboxAll();
		}
	}

	setStateCheckboxAll() {
		if (this.checkList) {
			let selectedCount = 0;

			this.checkList.forEach((item) => {
				if (item.state) {
					selectedCount++;
				}
			});

			if (selectedCount === this.checkList.length) {
				this.stateCheckAll = "checked";
				return;
			}

			if (selectedCount === 0) {
				this.stateCheckAll = "unchecked";
				return;
			}

			this.stateCheckAll = "part";
		} else {
			this.stateCheckAll = "unchecked";
		}
	}

	changeItem(check: CheckItem) {
		if (this.checkList) {
			this.checkList.forEach((item) => {
				if (item.id === check.id) {
					item.state = check.state;
				}
			});

			this.checkboxChange.emit(check);

			setTimeout(() => {
				this.setStateCheckboxAll();
			});
		}
	}
}
